import reducers from './reducers';
const initialState = {
  token: null,
  signed: false,
  loading: false,
};
const auth = (state = initialState, action) => {
  const { type, payload } = action;
  const reducer = reducers[type];
  if (reducer) {
    return reducer(state, payload);
  }
  return state;
};
export default auth;
